import React from "react";
import { profilePictures } from "@/lib/data";
import JiraIntegration from "@/assets/JiraIntegration.webp";
import Player from "@/assets/Player.gif";
import RecordingLink from "@/assets/RecordingLink.png";
import Comments from "@/assets/Comments.gif";

const mockChangelog = [
  {
    author: { name: "damian", profilePicture: profilePictures[0] },
    createdAt: "jan 30",
    paragraphs: [
      "you asked for it, we made it.",
      "we just published some additional screenshot tools.",
      "now you can not only comment and draw, but also:",
    ],
    list: [
      "create arrows",
      "create squares",
      "blur sensitive info",
      "the issue lands straight in your workspace.",
    ],
    img: Comments,
  },
  {
    author: { name: "damian", profilePicture: profilePictures[1] },
    createdAt: "dec 26",
    paragraphs: [
      "💥 BOOM... now you can request screen recordings from people.",
      "(tech support teams, you're welcome)",
      "imagine this:",
    ],
    img: RecordingLink,
    list: [
      "your user hits a bug.",
      "you send a link.",
      "they start recording through that link.",
      "the issue lands straight in your workspace.",
    ],
  },
  {
    author: { name: "sergiu", profilePicture: profilePictures[0] },
    createdAt: "dec 15",
    paragraphs: [
      "imagine loom, but with richer technical data and more AI",
      "we just improved our video player:",
    ],
    img: Player,
    list: [
      "fullscreen mode",
      "AI that summarizes the video with timestamps",
      "jump +15s / -15s with left/right arrows",
    ],
  },
  {
    author: { name: "damian", profilePicture: profilePictures[1] },
    createdAt: "dec 10",
    paragraphs: [
      "along with workspaces, we worked on something else:",
      "- jira integrations.",
      "connect it in settings and now...",
      "you can send issues to jira automatically with all the technical details included",
    ],
    img: JiraIntegration,
  },
  {
    author: { name: "sergiu", profilePicture: profilePictures[0] },
    createdAt: "nov 28",
    paragraphs: [
      "first update in the changelog",
      "one of the updates is… this changelog page itself. here’s where you’ll see all future changes",
      "but the big one: the dashboard got a full redesign. it’s a completely new dashboard now",
    ],
    list: [
      "workspaces: create teams per project or per company",
      "team: invite members via email or share the dashboard link (it’s right in the header, hehe)",
    ],
  },
];

const Changelog = () => {
  return (
    <div className="bg-gray-100 max-w-[540px] mx-auto rounded-[24px] relative overflow-scroll no-scrollbar w-full h-[calc(100vh-80px)] font-medium">
      <div className="sticky top-0 left-0 bg-gray-100 px-[20px] border-gray-300 border-b-[1px] text-[16px] leading-[24px] py-4 fl">
        What's new?
      </div>
      <div className="">
        {mockChangelog.map((changelog, i) => {
          return (
            <div
              key={i}
              className={`p-5 ${
                i !== mockChangelog.length - 1 ? "border-b-[1px]" : ""
              } border-gray-300`}
            >
              <div className="flex items-center gap-3 text-[14px] leading-[20px]">
                <img
                  src={changelog.author.profilePicture}
                  className="border-[1px] w-[32px] h-[32px] border-white/[0.32] rounded-[50%]"
                />

                <div className="">
                  <p className="text-gray-900">{changelog.author.name}</p>
                  <p className="text-white/[0.24]">
                    changelog {changelog.createdAt}
                  </p>
                </div>
              </div>
              {changelog?.paragraphs && (
                <div className="mt-5">
                  {changelog.paragraphs.map((p, i) => {
                    return (
                      <p
                        key={i}
                        className={`${
                          i !== changelog.paragraphs.length - 1
                            ? "mb-[20px]"
                            : ""
                        } text-[14px] leading-[24px]`}
                      >
                        {p}
                      </p>
                    );
                  })}
                </div>
              )}
              {changelog?.list && (
                <ul className="mt-5">
                  {changelog.list.map((li, i) => {
                    return (
                      <li
                        key={i}
                        className={`ml-[12px] list-disc text-[14px] leading-[24px]`}
                      >
                        {li}
                      </li>
                    );
                  })}
                </ul>
              )}
              {changelog.img && (
                <img className="mt-[20px] rounded-[16px]" src={changelog.img} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Changelog;
